<template>
<img alt="signature" :src="require(`@/assets/${signature.image}`)" :height="signature.heightPDF" aspect-ratio="1" />
</template>

<script>
export default {
  name: "Signature",
  props: ["signature"]
};
</script>
